import {inject} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {tap} from "rxjs";
import {LoaderActions} from "./loader.actions";
import {MatDialogRef} from "@angular/material/dialog";
import {DialogLoaderComponent} from "@gnv-shared/components";
import {DialogService} from "@gnv-shared/service";

export class LoaderEffect {
  private readonly actions$ = inject(Actions);
  private readonly dialogService = inject(DialogService);

  loader!: MatDialogRef<DialogLoaderComponent>;

  startActions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoaderActions.start),
      tap((param) => {
        this.loader = this.dialogService.openLoader(param.message);
      }),
    );
  }, { dispatch: false, functional: true });

  stopActions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LoaderActions.stop),
      tap(() => {
        this.loader?.close();
      }),
    );
  }, { dispatch: false, functional: true });
}
